import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const SECTION_SUBSECTIONS = {
  Math: ["Algebra", "Geometry", "Advanced Math"],
  Reading: ["Deduction", "Inference", "Main Idea"],
  English: ["Grammar", "Punctuation"],
  Science: ["Data", "Experiments"],
};

const AssignmentFiltersBar = ({ filters, setFilters }) => {
  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "section" ? { subSection: "ALL", calculator: "ALL" } : {}),
    }));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        mb: 4,
        p: 2,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(8px)",
        borderRadius: 3,
      }}
    >
      {/* SAT / ACT */}
      <FormControl size="small">
        <InputLabel>Test</InputLabel>
        <Select
          value={filters.testType}
          label="Test"
          onChange={(e) => handleChange("testType", e.target.value)}
        >
          <MenuItem value="ALL">All</MenuItem>
          <MenuItem value="SAT">SAT</MenuItem>
          <MenuItem value="ACT">ACT</MenuItem>
        </Select>
      </FormControl>

      {/* Section */}
      <FormControl size="small">
        <InputLabel>Section</InputLabel>
        <Select
          value={filters.section}
          label="Section"
          onChange={(e) => handleChange("section", e.target.value)}
        >
          <MenuItem value="ALL">All</MenuItem>
          <MenuItem value="Math">Math</MenuItem>
          <MenuItem value="Reading">Reading</MenuItem>
          <MenuItem value="English">English</MenuItem>
          <MenuItem value="Science">Science</MenuItem>
          <MenuItem value="Full">Full</MenuItem>
        </Select>
      </FormControl>

      {/* Subsection */}
      {filters.section !== "ALL" && filters.section !== "Full" && (
        <FormControl size="small">
          <InputLabel>Subsection</InputLabel>
          <Select
            value={filters.subSection}
            label="Subsection"
            onChange={(e) => handleChange("subSection", e.target.value)}
          >
            <MenuItem value="ALL">All</MenuItem>
            {(SECTION_SUBSECTIONS[filters.section] || []).map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {/* Calculator (Math only) */}
      {filters.section === "Math" && (
        <FormControl size="small">
          <InputLabel>Calculator</InputLabel>
          <Select
            value={filters.calculator}
            label="Calculator"
            onChange={(e) => handleChange("calculator", e.target.value)}
          >
            <MenuItem value="ALL">All</MenuItem>
            <MenuItem value="YES">Calculator</MenuItem>
            <MenuItem value="NO">No Calculator</MenuItem>
          </Select>
        </FormControl>
      )}

      {/* Starred */}
      <ToggleButtonGroup
        value={filters.starredOnly}
        exclusive
        onChange={() =>
          setFilters((p) => ({ ...p, starredOnly: !p.starredOnly }))
        }
      >
        <ToggleButton value={true}>
          <StarIcon sx={{ mr: 0.5 }} />
          Starred
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default AssignmentFiltersBar;
